import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { db } from "../../firebase";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import PiattoManGame from "./PiattoManGame";

export default function PiattoManWrapper() {
  const { localeTag, tableId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const tokenUrl = searchParams.get("token");

  const [menuDishes, setMenuDishes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tokenOk, setTokenOk] = useState(false);

  // 🔐 verifica token
  useEffect(() => {
    const checkToken = async () => {
      try {
        const ref = doc(db, "locali", localeTag, "tavoli", tableId);
        const snap = await getDoc(ref);

        if (!snap.exists()) return;

        const token = snap.data().tokenAttuale;

        if (token === tokenUrl) {
          setTokenOk(true);
        }

      } catch (err) {
        console.error(err);
      }
    };

    checkToken();
  }, [localeTag, tableId, tokenUrl]);

  // 🍝 carica menu
  useEffect(() => {
    const loadMenu = async () => {
      try {
        const snap = await getDocs(collection(db, "menu"));

        const dishes = snap.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .filter(d => d.localeTag === localeTag && d.visibile !== false);

        setMenuDishes(dishes);
        setLoading(false);

      } catch (err) {
        console.error(err);
      }
    };

    loadMenu();
  }, [localeTag]);

  if (loading) return <div style={{color: "white"}}>Caricamento...</div>;

  if (!tokenOk) {
    return <div style={{color: "white"}}>Sessione scaduta</div>;
  }

  return (
    <PiattoManGame
      localeTag={localeTag}
      tableId={tableId}
      tokenUrl={tokenUrl}
      menuDishes={menuDishes}
      onBack={() => navigate(`/giochi/${localeTag}/${tableId}?token=${tokenUrl}`)}
    />
  );
}